import * as service from './service'
export default {
  namespace: 'messageDetail',
  state: {
    noticeData: []
  },
  effects: {
    * getNoticeList ({ payload }, { call, put }) {
      const res = yield call(service.getNoticeList, payload)
      yield put({
        type: 'save',
        payload: {
          noticeData: res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
